import Vue from "vue";
import pinia from "@shared/store";
import DiscountDetails from "./DiscountDetails.vue";

export default new Vue({
  el: "#discount-details-pc-app",
  pinia,
  render: (h) => h(DiscountDetails),
});
